import { autoFocus, blur, permission } from '@meizhen/shared'
import dayjs from 'dayjs'
import dayjsZhCn from 'dayjs/locale/zh-cn'
import App from './App.vue'
import router from './router'
import './styles/index.scss'

dayjs.locale(dayjsZhCn)

const app = createApp(App)
app.directive('focus', autoFocus)
  .directive('blur', blur)
  .directive('permission', permission)
  .use(createPinia())
  .use(router)
  .mount('#app')
